// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1DZR9","label":"Completed_label__NZzlo"};